import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Link } from 'react-router-dom'
import { FaUser } from 'react-icons/fa'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import CambiarContrasena from './CambiarContrasena';

export default function BasicMenu() {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);
  const open = Boolean(anchorEl);
  const rol= localStorage.getItem('rol')

  

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setIsVisible(false);
    setAnchorEl(null);
  };
  const handleCambiarContraseña = (event) => {
    event.stopPropagation(); // detener la propagación del evento
    setIsVisible(true)
  };


  const handleLogoutConfirm = () => {
    localStorage.clear();
    handleClose();
    window.location.reload();
    window.location.replace('/');
  };

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        style={{ color: 'white', fontSize: '10px' }}
      >
        <FaUser size={15} style={{ color: 'white' }} />
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        
          <MenuItem onClick={handleCambiarContraseña} style={{ fontSize: '10px' }}>
            CAMBIAR CONTRASEÑA
            <CambiarContrasena
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            setAnchorEl={setAnchorEl}
            />
          </MenuItem>
        
        {rol==="admin"&&
        <Link to='/adminpanel'>
          <MenuItem onClick={handleClose} style={{ fontSize: '10px' }}>
            ADMIN
          </MenuItem>
        </Link>}
        <MenuItem onClick={handleDialogOpen} style={{ fontSize: '10px'}}>
          CERRAR SESIÓN
        </MenuItem>
      </Menu>
      <Dialog
        open={openDialog}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" className="bg-background_home text-white">
          ¿Seguro que quieres cerrar sesión?
        </DialogTitle>
        <div className="flex items-center justify-center">
        <DialogActions>
          <Button onClick={handleDialogClose} style={{ color: 'white', backgroundColor: '#2A824D' }}>
            Cancelar
          </Button>
          <Button onClick={handleLogoutConfirm} style={{ color: 'white', backgroundColor: '#2A824D' }}  autoFocus>
            Aceptar
          </Button>
        </DialogActions>
        </div>
      </Dialog>
    </div>
  );
}

